import { Vue, Component, toNative } from 'vue-facing-decorator';
import DiscountVoucherTable from 'components/Discounts/DiscountVoucher';
import Template from './template.vue';

@Component({
	components: {
		DiscountVoucherTable,
	},
	mixins: [Template],
})

class BulkDiscount extends Vue {}

export default toNative(BulkDiscount);
